export enum CardColorSchemeType {
  DARK = 'dark',
  LIGHT = 'light',
  PRIMARY = 'primary',
  PRIMARY_HOVER = 'primary-hover'
}
